import {
  ApolloClient,
  NormalizedCacheObject,
  createHttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import cache from './cache';
import { getCookie } from '@src/utils';

// Función para obtener las cookies de sesión principales
const getSessionCookies = () => {
  const sessionCookies = ['_legaroo_sid', '_legaroo_api_key'];
  return sessionCookies
    .map((name) => {
      const value = getCookie(name);
      return value ? `${name}=${value}` : null;
    })
    .filter(Boolean)
    .join('; ');
};

// Función para obtener el token de Auth0
const getAuth0Token = () => {
  // Buscar el token en localStorage
  const accessToken = localStorage.getItem('access_token');
  if (accessToken) {
    return accessToken;
  }

  // Buscar el token en sessionStorage
  const sessionToken = sessionStorage.getItem('access_token');
  if (sessionToken) {
    return sessionToken;
  }

  // Buscar en otros lugares comunes donde Auth0 puede almacenar el token
  const auth0Token = localStorage.getItem('auth0.access_token');
  if (auth0Token) {
    return auth0Token;
  }

  return null;
};

// Link para agregar headers con cookies de sesión y token de Auth0
const authLink = setContext((_, { headers }) => {
  const sessionCookies = getSessionCookies();
  const auth0Token = getAuth0Token();

  console.log('=== Apollo Client Debug ===');
  console.log('sessionCookies:', sessionCookies);
  console.log('auth0Token exists:', !!auth0Token);
  if (auth0Token) {
    console.log('auth0Token length:', auth0Token.length);
    console.log('auth0Token preview:', auth0Token.substring(0, 20) + '...');
  }

  const headersToSend: Record<string, string> = {
    ...headers,
  };

  // Agregar cookies de sesión si existen
  if (sessionCookies) {
    headersToSend.Cookie = sessionCookies;
    console.log('Cookie header added:', sessionCookies);
  }

  // Agregar token de Auth0 si existe
  if (auth0Token) {
    headersToSend.Authorization = `Bearer ${auth0Token}`;
    console.log('Authorization header added');
  }

  console.log('Final headers:', Object.keys(headersToSend));
  console.log('========================');

  return {
    headers: headersToSend,
  };
});

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL,
  credentials: 'include',
});

const apolloClient: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache,
  link: from([authLink, httpLink]),
});

export default apolloClient;
